// DetoxTeeTest.com - Product Data
// German Detox Tea Comparison Products

export const products = [
    {
        id: 1,
        rank: 1,
        name: "Lulutox Detox Tea",
        slug: "lulutox",
        image: "/images/products/luludex.png",
        badge: "Testsieger 2026",
        rating: 4.9,
        price: "€ 29,90",
        ingredients: "Matcha-Grüntee, Yerba Mate, Oolong-Tee, Sencha-Grüntee, Löwenzahnblatt, Ginseng, Mariendistel, Brennnesselblatt, Zitronengras, Goji-Beeren",
        taste: "Leichtes Pfirsich-Aroma",
        caffeine: "Enthält Koffein (18mg)",
        isDiuretic: true,
        affiliateLink: "https://cdn.detoxteetest.com/7ZRZD2?utm_term={keyword}&gclid={gclid}&utm_creative={creative}&utm_campaign={campaignid}&offer=lulutox-de",
        description: "Eine Detox-Teemischung, die laut Anbieter das Wohlbefinden unterstützen und u. a. Blähungsgefühle beruhigen sowie die Stoffwechsel-/Energie-Routine ergänzen soll.",
        features: [
            "Premium pyramidenförmige Teebeutel",
            "Vegan, glutenfrei, milchfrei, sojafrei",
            "30 Tage Geld-zurück-Garantie",
            "Reich an Antioxidantien"
        ]
    },
    {
        id: 2,
        rank: 2,
        name: "Serenatox Detox Tea",
        slug: "serenatox",
        image: "/images/products/serenatox.png",
        badge: "Preistipp",
        rating: 4.8,
        price: "€ 24,90",
        ingredients: "Grüntee, Brasilianischer Mate, Zitronenschale, Zitronengras, Fenchel, Goji-Beeren, Ingwerstücke, Brennnesselblätter, Ananasflocken",
        taste: "Kräuterig-zitrisch mit fruchtiger Note",
        caffeine: "Enthält Koffein",
        isDiuretic: true,
        affiliateLink: "https://cdn.detoxteetest.com/7ZRZD2?utm_term={keyword}&gclid={gclid}&utm_creative={creative}&utm_campaign={campaignid}&offer=serenatox-de",
        description: "Erfrischende Kräutertee-Mischung, die dabei helfen soll, sich leichter und energiegeladener zu fühlen. Passt in eine 24-Stunden-Routine (morgens Klarheit, nachmittags Balance, abends Ruhe).",
        features: [
            "Vegan und gentechnikfrei",
            "Unterstützung der Verdauung",
            "Sanfter Energieschub ohne Crash",
            "14 Tage Rückgaberecht"
        ]
    }
];

// FAQ Data
export const faqData = [
    {
        id: "faq-1",
        question: "Wo kann man Detox Tee kaufen?",
        answer: "Detox-Tees gibt es im Handel (Drogerie/Reformhaus/Apotheke) und online. Für aktuelle Preise, Verfügbarkeit, Garantie und Aktionen lohnt sich oft der Blick direkt beim jeweiligen Anbieter."
    },
    {
        id: "faq-2",
        question: "Hilft Detox Tee beim Abnehmen?",
        answer: "Ein Tee allein ist kein „Abnehm-Wunder“. Viele nutzen Detox-Tees aber als Ritual, um mehr zu trinken, Heißhunger zu überbrücken und sich weniger aufgebläht zu fühlen. Ob und wie stark sich das auf das Gewicht auswirkt, hängt vor allem von Ernährung, Bewegung und Schlaf ab – individuelle Erfahrungen können variieren."
    },
    {
        id: "faq-3",
        question: "Wie wird der Testsieger ermittelt?",
        answer: "Wir vergleichen u. a. Preis/Portion, Zutaten-Deklaration, Koffeinangaben, Geschmackprofil, Garantie/Rückgabe sowie Nutzerfeedback (Stand: Januar 2026). Der Testsieger ist das Produkt, das in Summe am ausgewogensten abschneidet – je nach Ziel (z. B. Preis) kann der Preistipp besser passen."
    },
    {
        id: "faq-4",
        question: "Wie finanziert sich diese Seite?",
        answer: "Diese Seite enthält Affiliate-Links. Wenn Sie über einen Link zum Anbieter wechseln, können wir eine Provision erhalten. Für Sie ändert sich der Preis in der Regel nicht. Das hilft uns, den Vergleich aktuell zu halten."
    },
    {
        id: "faq-5",
        question: "Worauf sollte man beim Bestellen achten?",
        answer: "Checkliste: 1) Zutatenliste & mögliche Allergene prüfen. 2) Koffein (für den Abend wichtig). 3) Preis pro Portion/Beutel vergleichen. 4) Garantie & Rückgabe lesen. 5) Bewertungen zum Geschmack/Verträglichkeit berücksichtigen."
    },
    {
        id: "faq-6",
        question: "Gibt es Nebenwirkungen oder Wechselwirkungen?",
        answer: "Wie bei allen Kräuter- und Koffeinprodukten können Unverträglichkeiten auftreten (z. B. Magen, Schlaf, Nervosität). Bei Schwangerschaft/Stillzeit, Vorerkrankungen oder Medikamenten bitte vorher mit Arzt/Apotheke abklären."
    },
    {
        id: "faq-7",
        question: "Wann merkt man einen Effekt?",
        answer: "Viele berichten von ersten „Wohlfühl“-Effekten (z. B. leichteres Gefühl/weniger aufgebläht) innerhalb weniger Tage bis 1–2 Wochen, vor allem wenn der Tee Teil einer festen Routine ist. Ergebnisse unterscheiden sich stark je nach Lebensstil."
    }
];
